import { render, staticRenderFns } from "./DealerModal.vue?vue&type=template&id=064b3421&scoped=true&"
import script from "./DealerModal.vue?vue&type=script&lang=js&"
export * from "./DealerModal.vue?vue&type=script&lang=js&"
import style0 from "./DealerModal.vue?vue&type=style&index=0&id=064b3421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b3421",
  null
  
)

export default component.exports